import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { L_FLOW_HEX, M_FLOW_HEX } from '../../../constants';
export const HEAT_EXCHANGER_SYNTHETIC_CONFIG = {
    type: ERFElement.HeatExchangerSynthetic,
    templates: [
        {
            code: 'default',
            ports: [
                {
                    id: 'target_material_annular_space_flow',
                    type: 'target',
                    name: 'Входной поток межтрубного пространства',
                    position: Position.Left,
                    style: { top: 26, left: 9, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'target_material_tubular_space_flow',
                    type: 'target',
                    name: 'Входной поток трубного пространства',
                    position: Position.Left,
                    style: { top: 46, left: 9, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_tubular_space_flow',
                    type: 'source',
                    name: 'Выходной поток трубного пространства',
                    position: Position.Right,
                    style: { top: 26, right: 9, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_annular_space_flow',
                    type: 'source',
                    name: 'Выходной поток межтрубного пространства',
                    position: Position.Right,
                    style: { top: 46, right: 9, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                /* PORTS FOR LOGICAL ELEMENTS */
                {
                    id: 'target_logical_flow',
                    type: 'target',
                    name: 'Входные параметры',
                    position: Position.Left,
                    style: { top: 64, left: 9, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: 'source_logical_flow',
                    type: 'source',
                    name: 'Выходные параметры',
                    position: Position.Right,
                    style: { top: 64, right: 9, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                }
            ]
        }
    ]
};
//# sourceMappingURL=RFHeatExchangerSyntheticNode.config.js.map